import { render, staticRenderFns } from "./BlockedUserList.vue?vue&type=template&id=6df40514&scoped=true"
import script from "./BlockedUserList.vue?vue&type=script&lang=js"
export * from "./BlockedUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df40514",
  null
  
)

export default component.exports